import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import AuthenticatedImage from './AuthenticatedImage';

const AuthenticatedAvatar = ({ src, alt, children, ...props }) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [src]);

  return (
    <Avatar {...props}>
      {src && !imageFailed ? (
        <AuthenticatedImage
          src={src}
          alt={alt}
          onError={() => setImageFailed(true)}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        children
      )}
    </Avatar>
  );
};

export default AuthenticatedAvatar;
